import { render, staticRenderFns } from "./type.vue?vue&type=template&id=2c5d3853&scoped=true"
import script from "./type.vue?vue&type=script&lang=js"
export * from "./type.vue?vue&type=script&lang=js"
import style0 from "./type.vue?vue&type=style&index=0&id=2c5d3853&prod&lang=scss&scoped=true"
import style1 from "./type.vue?vue&type=style&index=1&id=2c5d3853&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5d3853",
  null
  
)

export default component.exports